import "./LanguageSelectComponent.scss";
import template from "./LanguageSelectComponent.html";
import {IComponentOptions} from "angular";
import {LanguageService} from "../../service/LanguageService";
import {TranslationsLanguage} from "../../config/TranslationsLanguage";
import {Observable} from "rxjs";

export const LanguageSelect = "tfLanguageSelect";

export function languageSelect(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: LanguageSelectComponentController
    };
}

export class LanguageSelectComponentController {

    public readonly current$: Observable<TranslationsLanguage>;

    public readonly languages = Object.values(TranslationsLanguage);

    /** @ngInject */
    public constructor(private readonly languageService: LanguageService) {
        this.current$ = this.languageService.current();
    }

    public selectLanguage(language: TranslationsLanguage) {
        this.languageService.use(language);
    }
}
